import { BulkEditCommService } from '@common/facet/bulk-edit-comm.service';
import { WorkflowService } from '../services/workflow.service';
import { DataManagerService } from '@services/data-manager.service';
import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
} from '@angular/core';

import { LoggingService } from '@services/logging.service';
import { BulkEditToolbarComponent } from '@common/toolbars';
import { WorkflowBulkTemplatesComponent } from '../components';


@Component({
    selector: 'workflow-bulk-edit',
    templateUrl: './workflow-bulk-edit.component.html',
    providers: [
        BulkEditCommService
    ]
})
export class WorkflowBulkEditComponent implements OnInit {
    @Input() facet: any;
    @Input() tasks: any[];
    @Output() exit: EventEmitter<any> = new EventEmitter<any[]>();
    @ViewChild('bulkEditToolbar') bulkEditToolBar: BulkEditToolbarComponent;
    @ViewChild('bulkTemplates') bulkTemplates: WorkflowBulkTemplatesComponent;

    readonly COMPONENT_LOG_TAG = 'workflow-bulk-edit';

    constructor(
        private workflowService: WorkflowService,
        private loggingService: LoggingService,
        private dataManager: DataManagerService
    ) {
    }

    // lifecycle
    ngOnInit() {
        this.initialize();
    }

    initialize() {
         // Copy the input so we don't touch the grid data
        this.tasks = this.tasks.slice();
    }

    exitClicked() {
        if (this.dataManager.hasChanges()) {
            for (const task of this.tasks) {
                this.workflowService.cancelTaskInstance(task);
            }

            this.loggingService.logFacetUndoSuccess(this.COMPONENT_LOG_TAG);
        }

        this.exit.emit(this.tasks);
    }

    validate() {
        return this.bulkTemplates.validate();
    }
}
